<template>
  <admin-layout title="Recrutadores" menu="Recrutadores">
    <div class="row">
      <div class="col-lg-9 col-xs-12 overflow-auto">
        <div class="row">
          <div class="col-lg-12">
            <span class="ml-3 f14 label-bold"> NOME</span>
            <inputform
              v-model="recruiter.name"
              type="text"
              :field="$v.recruiter.name"
              class="label-bold mt-2"
            />
          </div>
          <div class="col-lg-12">
            <span class="ml-3 f14 label-bold"> EMAIL</span>
            <inputform
              v-model="recruiter.email"
              type="email"
              :field="$v.recruiter.email"
              class="label-bold mt-2"
            />
          </div>
          <div class="col-lg-12">
            <span class="ml-3 f14 label-bold"> TELEFONE</span>
            <inputform
              v-model="recruiter.mobile_phone"
              type="text"
              :field="$v.recruiter.mobile_phone"
              v-mask="'+## (##) #####-####'"
              class="label-bold mt-2"
            />
          </div>
          <div class="col-lg-12 form-group">
            <label>SENHA</label>
            <input
              type="password"
              class="form-control"
              v-model="recruiter.password"
              :class="{
                'is-valid': password_valid,
              }"
            />
            <Password
              v-model="recruiter.password"
              :strength-meter-only="true"
              @score="showScore"
            />
          </div>
        </div>
        <div class="col-lg-12 col-xs-12">
          <inertia-link :href="`/recruiters/teams`">
            <button type="button" class="mt-1 btn btnhoverprimary"
              style="border-radius: 0px">
              <font-awesome-icon icon="chevron-left" class="mr-3" />
              VOLTAR A LISTAGEM DE VAGA
            </button>
          </inertia-link>      
        </div>
      </div>
      <div class="col-lg-3 col-xs-12">
        <div class="row">
          <div class="col-lg-12 formJov p-2">
            <div class="row">
              <div class="col-lg-12 col-xs-12">
                <button
                  type="button"
                  @click="sendRecruiter"
                  class="btn full btn-primary f13 p-2 radius-0"
                >
                  SALVAR
                </button>
              </div>
              <div class="col-lg-12 mt-3">
                <div class="selectInput">
                  <span class="f10 pl-3 color-grey"
                    >STATUS DO RECRUTADOR(A)</span
                  >
                  <select v-model="recruiter.status" class="form-control">
                    <option
                      v-for="status in statusRecruiter"
                      :key="status.value"
                      :value="status.value"
                    >
                      {{ status.text }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-lg-12 col-xs-12 text-left mb-3 mt-3">
                <input type="checkbox" v-model="recruiter.is_admin" />
                <span>ADMINISTRADOR(A)?</span>
              </div>
              <div class="col-lg-12 col-xs-12 text-left mb-3">
                <input type="checkbox" v-model="recruiter.talent_bank" />
                <span>ACESSO AO BANCO DE TALENTOS ?</span>
              </div>
              <div class="col-lg-12 col-xs-12 text-left mb-3">
                <input type="checkbox" v-model="recruiter.limited" />
                <span>ACESSO LIMITADO ?</span>
              </div>
              <div class="col-lg-12 col-xs-12 text-left mb-3">
                <input type="checkbox" v-model="recruiter.is_evaluator" />
                <span>É AVALIADOR ?</span>
              </div>
              <div
                v-if="recruiter.is_evaluator"
                class="col-lg-12 col-xs-12 text-left mb-3"
              >
                <JobEvaluation
                  :recruiter="recruiter"
                  @setSchema="setSchema"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </admin-layout>
</template>

<script>
import {
  required,
  minLength,
  email,
  requiredIf,
} from "vuelidate/lib/validators";
import Password from "vue-password-strength-meter";
import JobEvaluation from "./JobEvaluation.vue";
export default {
  components: { Password, JobEvaluation },
  props: ["recruiter_edit"],
  mounted() {
    if (this.recruiter_edit != undefined) {
      this.recruiter = {
        name: this.recruiter_edit.name,
        email: this.recruiter_edit.email,
        business_name: this.recruiter_edit.business_name,
        mobile_phone: this.recruiter_edit.mobile_phone,
        status: this.recruiter_edit.status,
        is_admin: this.recruiter_edit.recruiter_admin_id > 0 ? false : true,
        talent_bank: this.recruiter_edit.talent_bank,
        limited: this.recruiter_edit.limited,
        is_evaluator: this.recruiter_edit.is_evaluator,
        schema_params: this.recruiter_edit.schema_params,
      };
    }
  },
  data: () => ({
    statusRecruiter: [
      { text: "Desativado", value: 0 },
      { text: "Ativo", value: 1 },
      { text: "Bloqueado", value: 2 },
      { text: "Deletado", value: 3 },
    ],
    password_valid: false,
    strength: 0,
    load: false,
    recruiter: {
      name: "",
      email: "",
      password: "",
      mobile_phone: "",
      status: "1",
      is_admin: false,
      talent_bank: true,
      limited: false,
      is_evaluator: false,
      schema_params: null,
    },
  }),
  methods: {
    showScore(score) {
      if (score) this.strength = score;
    },
    sendRecruiter() {
      let request = {};
      if (this.load == true) {
        return;
      }
      this.load = true;

      this.$v.recruiter.$touch();
      if (this.$v.recruiter.$invalid) {
        this.$toast.error("Preencha o formulário corretamente !");
        this.load = false;
        return;
      }

      if (
        this.recruiter.password != "" &&
        this.strength < 3 &&
        this.recruiter.password != undefined
      ) {
        this.$toast.error("Preencha a senha corretamente");
        this.load = false;
        return;
      }
      if (
        this.recruiter.schema_params?.job_id &&
        !this.recruiter.schema_params?.selective_process_id
      ) {
        this.$toast.error("Preencha a vaga e o processo seletivo corretamente");
        this.load = false;
        return;
      }

      let recruiter_attr = {
        name: this.recruiter.name,
        email: this.recruiter.email,
        password: this.recruiter.password,
        mobile_phone: this.recruiter.mobile_phone,
        status: this.recruiter.status,
        is_admin: this.recruiter.is_admin,
        talent_bank: this.recruiter.talent_bank,
        limited: this.recruiter.limited,
        is_evaluator: this.recruiter.is_evaluator,
        schema_params: this.recruiter.schema_params,
      };

      if (this.recruiter_edit) {
        request = axios.put(
          `/recruiters/teams/${this.recruiter_edit.id}/update`,
          {
            recruiter: recruiter_attr,
          }
        );
      } else {
        if (this.recruiter.password == "") {
          this.$toast.error("Preencha a senha corretamente");
          this.load = false;
          return;
        }
        request = axios.post("create", {
          recruiter: recruiter_attr,
        });
      }

      request
        .then((response) => {
          if (!response.data.status) {
            this.$toast.error(response.data.message);
            this.load = false;
            return;
          }
          this.$toast.success("Recrutador salvo com sucesso");
          setTimeout(() => {
            this.load = false;
            this.$inertia.visit(`/recruiters/teams`, {
              method: "get",
              data: {},
              replace: false,
              preserveState: false,
              preserveScroll: true,
              only: [],
            });
          }, 800);
        })
        .catch((err) => {
          this.load = false;
        });
    },
    setSchema(params) {
      this.recruiter.schema_params = params;
    }
  },
  watch: {
    strength(new_strength) {
      if (new_strength >= 3) {
        this.password_valid = true;
        return;
      }
      this.password_valid = false;
    },
  },
  validations: {
    recruiter: {
      name: { required, minLength: minLength(3) },
      email: { required, minLength: minLength(3), email },
      mobile_phone: { required },
    },
  },
};
</script>